export type DateFormat =
  | 'date'
  | 'dateName'
  | 'dateNameTime'
  | 'dateSlash'
  | 'time'
  | 'dateTime'
  | 'dateTimeSecond'
  | 'dateTimeSlash'
  | 'dateTimeSlashSecond';

export const FORMAT_DATE = {
  date: 'YYYY-MM-DD',
  dateName: 'dddd, DD MMMM YYYY',
  dateNameTime: 'dddd, DD MMMM YYYY HH:mm',
  dateSlash: 'YYYY/MM/DD',
  time: 'HH:mm:ss',
  dateTime: 'YYYY-MM-DD HH:mm',
  dateTimeSecond: 'YYYY-MM-DD HH:mm:ss',
  dateTimeSlash: 'YYYY/MM/DD HH:mm',
  dateTimeSlashSecond: 'YYYY/MM/DD HH:mm:ss'
};
